import React from 'react'
import PropTypes from 'prop-types'
import { Button, Flex, Hide } from 'pcln-design-system'
import noop from 'lodash/noop'

import { getCabinNames } from '../Itinerary/helpers'

const MobileSliceCtaButton = ({
  hasExpressDeal,
  listings,
  onListingItemSelect,
  getRetailCount,
  brandReference,
}) => {
  const handleClick = () => {
    let itinerary
    if (hasExpressDeal || listings[0].isExpressDeal) {
      itinerary = listings[1]
    } else {
      itinerary = listings[0]
    }
    onListingItemSelect({
      id: itinerary.id,
      gaIndex: getRetailCount,
      itinerary,
      cabinNames: getCabinNames(itinerary, brandReference),
    })
  }

  return (
    <Hide m lg xl xxl>
      <Flex justifyContent='center'>
        <Button
          data-autobot-element-id='slice_mobile_cta'
          size='large'
          width={'80%'}
          onClick={handleClick}
          color='secondary'
        >
          {' '}
          Continue{' '}
        </Button>
      </Flex>
    </Hide>
  )
}

MobileSliceCtaButton.defaultProps = {
  onListingItemSelect: noop,
}

MobileSliceCtaButton.propTypes = {
  onClick: PropTypes.func,
  hasExpressDeal: PropTypes.bool,
  retailItinCount: PropTypes.number,
  brandReference: PropTypes.object,
  listings: PropTypes.array,
  getRetailCount: PropTypes.number,
  onListingItemSelect: PropTypes.func,
}

export default MobileSliceCtaButton
